import {BaseContainerModel} from "../../../base-container.model";
import {
    bl_alg_cc_automation_rule_hdr_RowClass,
    bl_alg_cc_automation_rule_hdr_RowInterface
}from "../../../../dbschema"

export class AutomationRuleContainerModel extends BaseContainerModel{
    bl_alg_cc_automation_rule_hdr : bl_alg_cc_automation_rule_hdr_RowInterface = new bl_alg_cc_automation_rule_hdr_RowClass
}